import { AccommodationSummaryCard } from "@/components/AccommodationSummaryCard/AccommodationSummaryCard.tsx";
import { ExtrasGrid } from "@/components/ExtrasGrid/ExtrasGrid.tsx";
import { RatePlanSwitcher } from "@/components/RatePlanSwitcher/RatePlanSwitcher.tsx";
import { useGetOptions } from "@/components/ReservationOptions/hooks/useGetOptions.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";

export const ExtraOptionsAccommodationBlock = ({ item }: { item: CartAccommodationItem }) => {
  const { optionalExtras, mandatoryExtras } = useGetOptions(item);

  return (
    <div className="c-extras__accommodation-block">
      <AccommodationSummaryCard item={item} />
      <RatePlanSwitcher item={item} showChevron={false} />
      <ExtrasGrid optionalExtras={optionalExtras} mandatoryExtras={mandatoryExtras} cartItem={item} />
    </div>
  );
};
